import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { PurchaseOrderDetailModel } from 'src/app/models/shopping/purchase-order-detail.model';
import { ArticlesForPurchaseOrderTableModel } from 'src/app/models/tables/shopping/article-for-purchase-order-table.model';
import { ArticlesWithOrderForPurchaseOrderTableModel } from 'src/app/models/tables/shopping/article-with-order-for-purchase-order-table.model';
import { PurchaseDetailRegisterModel } from 'src/app/models/tables/shopping/purchase-order-detail-register-table.model';
import { PurchaseOrderDetailTableModel } from 'src/app/models/tables/shopping/purchase-order-detail-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PurchaseOrderDetailService {

  constructor(private _httpClient: HttpClient) { }

  createPurchaseOrderDetails(articleIds: number[], purchaseOrderId: number): Observable<boolean> {
    const params = new HttpParams().set('purchaseOrderId', purchaseOrderId)
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrderDetail.CreatePurchaseOrderDetails}`,
      articleIds, { params: params }
    );
  }

  createPurchaseOrderDetailsWithOrder(articlesWithOrder: ArticlesWithOrderForPurchaseOrderTableModel[], purchaseOrderId: number): Observable<boolean> {
    const params = new HttpParams().set('purchaseOrderId', purchaseOrderId)
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrderDetail.CreateWithOrdersPurchaseOrderDetails}`,
      articlesWithOrder, { params: params }
    );
  }

  deleteSomeDetails(ids: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrderDetail.DeleteSomeDetails}`,
      ids);
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString());

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrderDetail.ExportDetailConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getArticlesForSelection(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<ArticlesForPurchaseOrderTableModel>> {
    let params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<ArticlesForPurchaseOrderTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrderDetail.GetArticlesForSelection}`,
      filters, { params: params }
    );
  }

  getArticlesWithOrderForSelection(branchId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<ArticlesWithOrderForPurchaseOrderTableModel>> {
    let params = new HttpParams()
      .set('branchId', branchId)
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<ArticlesWithOrderForPurchaseOrderTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrderDetail.GetArticlesWithOrderForSelection}`,
      filters, { params: params }
    );
  }

  getColumnsForArticleSelection(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrderDetail.GetColumnsForArticleSelection}`);
  }

  getColumnsForArticleWithOrderSelection(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrderDetail.GetColumnsForArticleWithOrderSelection}`);
  }

  getColumnsForCaptureTable(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrderDetail.GetColumnsForCaptureTable}`);
  }

  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrderDetail.GetColumnsForDetailConsultation}`);
  }

  getPurchaseOrderDetailById(purchaseOrderDetailId: number): Observable<PurchaseOrderDetailModel> {
    const params = new HttpParams().set('purchaseOrderDetailId', purchaseOrderDetailId);
    return this._httpClient.get<PurchaseOrderDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrderDetail.GetPurchaseOrderDetailById}`,
      { params: params }
    );
  }

  getPurchaseOrderDetailByKeys(purchaseOrderId: number, articleId: number): Observable<PurchaseOrderDetailModel> {
    const params = new HttpParams().set('purchaseOrderId', purchaseOrderId).set('articleId', articleId);
    return this._httpClient.get<PurchaseOrderDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrderDetail.GetPurchaseOrderDetailByKeys}`,
      { params: params }
    );
  }

  getPurchaseOrderDetailsForCaptureTable(page: number, limit: number, columnSort: string | null, ascendant: boolean, purchaseOrderId: number): Observable<PagedResponseModel<PurchaseDetailRegisterModel>> {
    let params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('purchaseOrderId', purchaseOrderId);

    return this._httpClient.get<PagedResponseModel<PurchaseDetailRegisterModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrderDetail.GetPurchaseOrderDetailsForCaptureTable}`,
      { params: params }
    );
  }

  getPurchaseOrderDetailsForDetailConsultation(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<PurchaseOrderDetailTableModel>> {
    let params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<PurchaseOrderDetailTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrderDetail.GetPurchaseOrderDetailsForDetailConsultation}`,
      filters, { params: params }
    );
  }

  updatePurchaseOrderDetail(purchaseOrderDetailModel: PurchaseOrderDetailModel): Observable<PurchaseOrderDetailModel> {
    return this._httpClient.put<PurchaseOrderDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrderDetail.UpdatePurchaseOrderDetail}`,
      purchaseOrderDetailModel);
  }
}
